// frontend/src/components/QuantixGo/ImageImportHistoryPanel.jsx

import React, { useState, useEffect } from 'react';
import { quantixgoAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';

const ImageImportHistoryPanel = ({ visible }) => {
  const { t } = useTranslation();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    setLoading(true);
    quantixgoAPI.getImageImportLog(20)
      .then((res) => setEntries(res.data?.data || []))
      .catch((err) => console.error('Failed to load image import log:', err))
      .finally(() => setLoading(false));
  }, [visible]);

  const toggleDetail = async (id) => {
    if (expandedId === id) {
      setExpandedId(null);
      setDetail(null);
      return;
    }
    setExpandedId(id);
    setDetailLoading(true);
    try {
      const res = await quantixgoAPI.getImageImportLogDetail(id);
      setDetail(res.data?.data);
    } catch (err) {
      console.error('Failed to load import log detail:', err);
    } finally {
      setDetailLoading(false);
    }
  };

  if (!visible) return null;

  return (
    <div style={{ marginTop: '16px', border: '1px solid #ddd', borderRadius: '6px', padding: '12px' }}>
      {loading ? (
        <p>{t('quantixgo.imageImport.loading', 'Loading...')}</p>
      ) : entries.length === 0 ? (
        <p>{t('quantixgo.imageImport.noRuns', 'No import runs yet.')}</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
              <th style={{ padding: '4px' }}>{t('quantixgo.imageImport.startedAt', 'Started')}</th>
              <th style={{ padding: '4px' }}>{t('quantixgo.imageImport.added', 'Added')}</th>
              <th style={{ padding: '4px' }}>{t('quantixgo.imageImport.updated', 'Updated')}</th>
              <th style={{ padding: '4px' }}>{t('quantixgo.imageImport.unchanged', 'Unchanged')}</th>
              <th style={{ padding: '4px' }}>{t('quantixgo.imageImport.ignored', 'Ignored')}</th>
              <th style={{ padding: '4px' }}>{t('quantixgo.imageImport.removed', 'Removed')}</th>
              <th style={{ padding: '4px' }}></th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <React.Fragment key={entry.image_import_log_id}>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '4px' }}>{new Date(entry.started_at).toLocaleString()}</td>
                  <td style={{ padding: '4px' }}>{entry.added}</td>
                  <td style={{ padding: '4px' }}>{entry.updated}</td>
                  <td style={{ padding: '4px' }}>{entry.unchanged}</td>
                  <td style={{ padding: '4px' }}>{entry.ignored}</td>
                  <td style={{ padding: '4px' }}>{entry.removed}</td>
                  <td style={{ padding: '4px' }}>
                    <button className="btn btn-secondary" onClick={() => toggleDetail(entry.image_import_log_id)}>
                      {expandedId === entry.image_import_log_id
                        ? t('quantixgo.imageImport.hide', 'Hide')
                        : t('quantixgo.imageImport.details', 'Details')}
                    </button>
                  </td>
                </tr>
                {expandedId === entry.image_import_log_id && (
                  <tr>
                    <td colSpan={7} style={{ padding: '8px', background: '#fafafa' }}>
                      {detailLoading ? (
                        <span>{t('quantixgo.imageImport.loading', 'Loading...')}</span>
                      ) : (
                        <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px', maxHeight: '300px', overflow: 'auto' }}>
                          {detail?.log_text}
                        </pre>
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ImageImportHistoryPanel;